<template>
  <div class="Xtextboxfilter">
    <input type="text" v-bind:placeholder="placeholder" v-model="Filter" class="form-control" />
  </div>
</template>

<script>
'use strict'
import { EventBus } from 'pevueglobal'
export default {
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    name: {
      type: String,
    },
  },
  data() {
    return {
      filtervalue: '',
      type: 'textbox',
    }
  },
  mounted: function () {
    EventBus.$on('FilterDeleted', (filter) => {
      if (filter.name === this.name) {
        this.keuzeText = ''
        this.Filter = ''
      }
    })
  },
  computed: {
    Filter: {
      get: function () {
        return this.filtervalue
      },
      set: function (value) {
        this.filtervalue = value
        if (value === '') {
          this.$store.commit('deleteFilter', this.name)
        } else {
          var myfilter = { type: this.type, name: this.name, value: this.filtervalue, text: this.filtervalue }
          this.$store.commit('setFilter', myfilter)
        }
        // this.$emit('updateFilter')
      },
    },
  },
}
</script>
